import { get, post } from '@/request/request';

export default {
  list(params) {
    return get('/admin/customer/list', params);
  },
  info(params) {
    return get('/admin/customer/info', params);
  },
  save(params) {
    return post('/admin/customer/save', params);
  },
  delete(params) {
    return post('/admin/customer/delete', params);
  }
};
